// src/components/dashboard/widgets/weather-widget.tsx
import { Cloud } from 'lucide-react';
import { useAppColors } from '@/src/lib/theme';

interface WeatherWidgetProps {
  weather: { temp: number; description: string; icon: string } | null;
}

export default function WeatherWidget({ weather }: WeatherWidgetProps) {
  const c = useAppColors();
  return (
    <div className="rounded-2xl border p-4 bg-warm-gray border-leaf-500/20 h-full">
      <div className="flex items-center justify-between mb-3">
        <div className="w-8 h-8 rounded-lg bg-leaf-500/10 flex items-center justify-center">
          <Cloud size={15} className="text-leaf-400" />
        </div>
        <span className="text-[9px] font-bold tracking-widest text-cream-muted/50 uppercase">Weather</span>
      </div>
      {weather ? (
        <>
          <div className="text-2xl font-semibold leading-none mb-1 text-cream">
            {weather.icon} {weather.temp}°C
          </div>
          <div className="text-xs text-cream-muted">{weather.description}</div>
        </>
      ) : (
        <div className="text-xs text-cream-muted/50">Loading…</div>
      )}
    </div>
  );
}